import React, { useEffect, useState } from 'react';
import cl from "../css/Privacy.module.css";
import mainCl from "../css/mainStyle.module.css";
import { Link } from "react-router-dom";
import arrow from "../images/right-arrow.svg";
import { scheduleAPI, ScheduleItem } from '../api/api';

const daysOfWeek = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];

export const Schedule: React.FC = () => {
    const [schedule, setSchedule] = useState<ScheduleItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadSchedule = async () => {
            try {
                setLoading(true);
                const data = await scheduleAPI.getAll();
                setSchedule(data);
                setError(null);
            } catch (err) {
                setError('Не удалось загрузить расписание');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadSchedule();
    }, []);

    // Получаем уникальные предметы (в порядке появления)
    const uniqueSubjects = schedule
        .filter((item, index, self) =>
            index === self.findIndex(t => t.subject === item.subject)
        )
        .map(item => item.subject);

    // Группируем расписание по дням
    const scheduleByDay = daysOfWeek.reduce((acc, day) => {
        acc[day] = schedule.filter(item => item.day_of_week === day);
        return acc;
    }, {} as Record<string, ScheduleItem[]>);

    // Функция для поиска времени по дню и предмету
    const findScheduleItem = (day: string, subject: string): ScheduleItem | undefined => {
        return scheduleByDay[day].find(item => item.subject === subject);
    };

    // Форматирование времени
    const formatTime = (time: string | null): string => {
        if (!time || time === '00:00:00') return '';
        return time.substring(0, 5);
    };

    if (loading) {
        return (
            <div className={`${mainCl.home__row}`}>
                <div className={`${mainCl.home__cell}`}>
                    <div className={`${mainCl.home__cell__block}`}>
                        <h2>Расписание занятий</h2>
                        <p>Загрузка расписания...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={cl.privacy}>
            <div className={cl.wrapper}>
                <div className={cl.wrapperContainer}>
                    <h1>Расписание</h1>
                </div>
            </div>

            <div className={cl.privacy__line}>
                <div className={cl.privacy__line__block}>
                    <Link to="/">Главная</Link>
                </div>
                <div className={cl.privacy__line__block}>
                    <img src={arrow} alt="" />
                </div>
                <div className={cl.privacy__line__block}>
                    Расписание
                </div>
            </div>

            <div className={`${mainCl.home__row}`}>
                <div className={`${mainCl.home__cell}`} style={{padding: "0"}}>
                    <div className={`${mainCl.home__cell__block}`}>
                        <p className={mainCl.home__blockText}>
                            Здесь будет актуальное расписание занятий и важные новости центра «Эмпириум».
                        </p>

                        {error && <p className="error">{error}</p>}

                        <div className={cl.schedulePublicTable}>
                            <table>
                                <thead>
                                <tr>
                                    <th></th>
                                    {uniqueSubjects.map(subject => (
                                        <th key={subject}>{subject}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {daysOfWeek.map(day => (
                                    <tr key={day}>
                                        <td className={cl.dayName}>
                                            <b>{day}</b>
                                        </td>
                                        {uniqueSubjects.map(subject => {
                                            const item = findScheduleItem(day, subject);
                                            return (
                                                <td key={`${day}-${subject}`}>
                                                    {item && item.time_start && item.time_start !== '00:00:00' && item.time_end && item.time_end !== '00:00:00'
                                                        ? `${formatTime(item.time_start)}-${formatTime(item.time_end)}`
                                                        : ''
                                                    }
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};